export const actionTypes = {
  SET_VISIBLE_SIDEBAR: "COMMON:SET_VISIBLE_SIDEBAR",
  SET_ALLOW_SIDEBAR: "COMMON:SET_ALLOW_SIDEBAR",
  SET_IS_HIDE_DOWNLOAD_MODAL: "COMMON:SET_IS_HIDE_DOWNLOAD_MODAL",
}